import { Navigate } from "react-router-dom";
import { useAppConfig } from "@context/AppConfigContext";
import { canAccessRoute } from "@utils/index";

const ProtectedRoute = ({ children, requiredPath }) => {
  const { user } = useAppConfig();

  // If no user is logged in, redirect to login
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // Check if user has permission to access this route
  if (!canAccessRoute(user?.user, requiredPath)) {
    // Redirect to dashboard if user doesn't have permission
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
